import { render } from "./index.vue?vue&type=template&id=7b129ad2"
const script = {}

import "./style.less?vue&type=style&index=0&lang=less"
script.render = render

export default script